import { toast } from "react-toastify";

import AudiencesService from "Services/audiences";
import I18n from "Services/i18n";

export const LOAD_AUDIENCES_REQUESTED = "LOAD_AUDIENCES_REQUESTED";
export const LOAD_AUDIENCES_OK = "LOAD_AUDIENCES_OK";
export const LOAD_AUDIENCES_FAIL = "LOAD_AUDIENCES_FAIL";

export const CREATE_AUDIENCES_REQUESTED = "CREATE_AUDIENCES_REQUESTED";
export const CREATE_AUDIENCES_OK = "CREATE_AUDIENCES_OK";
export const CREATE_AUDIENCES_FAIL = "CREATE_AUDIENCES_FAIL";

export const DELETE_AUDIENCES_REQUESTED = "DELETE_AUDIENCES_REQUESTED";
export const DELETE_AUDIENCES_OK = "DELETE_AUDIENCES_OK";
export const DELETE_AUDIENCES_FAIL = "DELETE_AUDIENCES_FAIL";

export const UPDATE_AUDIENCES_REQUEST = "UPDATE_AUDIENCES_REQUEST";
export const UPDATE_AUDIENCES_OK = "UPDATE_AUDIENCES_OK";
export const UPDATE_AUDIENCES_FAIL = "UPDATE_AUDIENCES_FAIL";

export const UPDATE_AUDIENCES_COUNT_REQUEST = "UPDATE_AUDIENCES_COUNT_REQUEST";
export const UPDATE_AUDIENCES_COUNT_OK = "UPDATE_AUDIENCES_COUNT_OK";
export const UPDATE_AUDIENCES_COUNT_FAIL = "UPDATE_AUDIENCES_COUNT_FAIL";

export function loadCount() {
  return (dispatch) => {
    dispatch({ type: UPDATE_AUDIENCES_COUNT_REQUEST });

    AudiencesService.getCount()
      .then((data) => {
        dispatch({
          type: UPDATE_AUDIENCES_COUNT_OK,
          data,
        });
      })
      .catch((errors) => {
        dispatch({
          type: UPDATE_AUDIENCES_COUNT_FAIL,
          errors,
        });
      });
  };
}

export function load() {
  return (dispatch) => {
    dispatch({ type: LOAD_AUDIENCES_REQUESTED });

    AudiencesService.load()
      .then((data) => {
        dispatch({
          type: LOAD_AUDIENCES_OK,
          data,
        });
      })
      .catch((errors) => {
        dispatch({
          type: LOAD_AUDIENCES_FAIL,
          errors,
        });
      });
  };
}

export function create(data, zoneId) {
  return (dispatch) => {
    dispatch({ type: CREATE_AUDIENCES_REQUESTED });

    AudiencesService.create(data, zoneId)
      .then((data) => {
        dispatch({
          type: CREATE_AUDIENCES_OK,
          data,
        });
        dispatch(load());
        toast.success(I18n.getStringByKey("toast_success-audience-created"));
      })
      .catch((errors) => {
        dispatch({
          type: CREATE_AUDIENCES_FAIL,
          errors,
        });

        if (errors && errors.Status && errors.Status === "audience duplicate") {
          toast.warning(I18n.getStringByKey("toast_error-audience-duplicate"), {
            autoClose: false,
          });
        } else {
          toast.error(I18n.getStringByKey("toast_error-audience-create"));
        }
      });
  };
}

export function update(data) {
  return (dispatch) => {
    dispatch({ type: UPDATE_AUDIENCES_REQUEST });

    AudiencesService.update(data)
      .then((data) => {
        dispatch({
          type: UPDATE_AUDIENCES_OK,
          data,
        });
        dispatch(load());
        toast.success(I18n.getStringByKey("toast_success-audience-update"));
      })
      .catch((errors) => {
        dispatch({
          type: UPDATE_AUDIENCES_FAIL,
          errors,
        });
        if (errors && errors.Status && errors.Status === "audience duplicate") {
          toast.warning(I18n.getStringByKey("toast_error-audience-duplicate"), {
            autoClose: false,
          });
        } else {
          toast.error(I18n.getStringByKey("toast_error-audience-update"));
        }
      });
  };
}

export function remove(audienceId) {
  return (dispatch) => {
    dispatch({ type: DELETE_AUDIENCES_REQUESTED });

    AudiencesService.delete(audienceId)
      .then((data) => {
        dispatch({
          type: DELETE_AUDIENCES_OK,
          data,
        });
        dispatch(load());
        toast.success(I18n.getStringByKey("toast_success-audience-deleted"));
      })
      .catch((errors) => {
        dispatch({
          type: DELETE_AUDIENCES_FAIL,
          errors,
        });
        toast.error(I18n.getStringByKey("toast_error-audience-delete"));
      });
  };
}
